import React, { useEffect, useState } from "react";
//Syles
import styles from "./StudentTutorial.module.css";

// Material UI Components
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { Typography } from "@mui/material";

// MUI icons
import SlowMotionVideoOutlinedIcon from "@mui/icons-material/SlowMotionVideoOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EastOutlinedIcon from "@mui/icons-material/EastOutlined";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CloseIcon from "@mui/icons-material/Close";

// redux
import { useSelector, useDispatch } from "react-redux";
import { setDemoObj } from "../../store/demo.actions";
import { setTutorialExpanded } from "../../store/tutorial.actions";

//Components
import StudentDemo from "../StudentDemo";
import VideoModal from "../VideoModal/VideoModal";

const cardDemoList = [
  "Guided Walkthrough",
  "Interactive Features",
  "Personalized Experience",
];

//dummy data to check the functionality of the component
const data = [
  // {
  //   category: "Dashboard",
  //   items: [
  //     {
  //       title: "Discover Emerging Trends",
  //       videoLink: "https://www.youtube.com/embed/3fumBcKC6RE",
  //     },
  //     {
  //       title: "See the top questions consumers ask about any topic",
  //       videoLink: "https://www.youtube.com/embed/ysz5S6PUM-U",
  //     },
  //     {
  //       title: "See where consumers are talking most about any topic",
  //       videoLink: "https://www.youtube.com/embed/dQw4w9WgXcQ",
  //     },
  //     {
  //       title: "Differentiate fads from trends",
  //       videoLink: "https://www.youtube.com/embed/jNQXAC9IVRw",
  //     },
  //     {
  //       title: "Forecast Future Market Conditions",
  //       videoLink: "https://www.youtube.com/embed/oHg5SJYRHA0",
  //     },
  //     {
  //       title: "See what consumers are searching on different channels",
  //       videoLink: "https://www.youtube.com/embed/tgbNymZ7vqY",
  //     },
  //   ],
  // },
  {
    category: "MY Study Room",
    items: [
      {
        title: "What is MY Study Room and how to use it?",
        videoLink:
          "https://www.youtube.com/embed/PBZ_v7gVBXI?si=JKUzsldGRRdmPviL",
      },
      // {
      //   title: "Discover Emerging Trends",
      //   videoLink: "https://www.youtube.com/embed/3fumBcKC6RE",
      // },
      // {
      //   title: "See the top questions consumers ask about any topic",
      //   videoLink: "https://www.youtube.com/embed/ysz5S6PUM-U",
      // },
      // {
      //   title: "Differentiate fads from trends",
      //   videoLink: "https://www.youtube.com/embed/jNQXAC9IVRw",
      // },
      // {
      //   title: "Forecast Future Market Conditions",
      //   videoLink: "https://www.youtube.com/embed/oHg5SJYRHA0",
      // },
      // {
      //   title: "See what consumers are searching on different channels",
      //   videoLink: "https://www.youtube.com/embed/tgbNymZ7vqY",
      // },
    ],
  },
  // {
  //   category: "Smart Learning",
  //   items: [
  //     {
  //       title: "See the top questions consumers ask about any topic",
  //       videoLink: "https://www.youtube.com/embed/ysz5S6PUM-U",
  //     },
  //     {
  //       title: "See where consumers are talking most about any topic",
  //       videoLink: "https://www.youtube.com/embed/dQw4w9WgXcQ",
  //     },
  //     {
  //       title: "Differentiate fads from trends",
  //       videoLink: "https://www.youtube.com/embed/jNQXAC9IVRw",
  //     },
  //     {
  //       title: "Discover Emerging Trends",
  //       videoLink: "https://www.youtube.com/embed/3fumBcKC6RE",
  //     },
  //     {
  //       title: "Forecast Future Market Conditions",
  //       videoLink: "https://www.youtube.com/embed/oHg5SJYRHA0",
  //     },
  //     {
  //       title: "See what consumers are searching on different channels",
  //       videoLink: "https://www.youtube.com/embed/tgbNymZ7vqY",
  //     },
  //   ],
  // },
  {
    category: "MY Exam Room",
    items: [
      {
        title: "What is MY Exam Room and how to use it?",
        videoLink:
          "https://www.youtube.com/embed/w7M0oCKfUwk?si=LK9DQswWj0DU5oaT",
      },
      // {
      //   title: "Discover Emerging Trends",
      //   videoLink: "https://www.youtube.com/embed/3fumBcKC6RE",
      // },
      // {
      //   title: "See the top questions consumers ask about any topic",
      //   videoLink: "https://www.youtube.com/embed/ysz5S6PUM-U",
      // },
      // {
      //   title: "See where consumers are talking most about any topic",
      //   videoLink: "https://www.youtube.com/embed/dQw4w9WgXcQ",
      // },
      // {
      //   title: "Differentiate fads from trends",
      //   videoLink: "https://www.youtube.com/embed/jNQXAC9IVRw",
      // },
      // {
      //   title: "Forecast Future Market Conditions",
      //   videoLink: "https://www.youtube.com/embed/oHg5SJYRHA0",
      // },
    ],
  },
  // {
  //   category: "Report & Analytics",
  //   items: [
  //     {
  //       title: "Discover Emerging Trends",
  //       videoLink: "https://www.youtube.com/embed/3fumBcKC6RE",
  //     },
  //     {
  //       title: "See the top questions consumers ask about any topic",
  //       videoLink: "https://www.youtube.com/embed/ysz5S6PUM-U",
  //     },
  //     {
  //       title: "See where consumers are talking most about any topic",
  //       videoLink: "https://www.youtube.com/embed/dQw4w9WgXcQ",
  //     },
  //     {
  //       title: "Differentiate fads from trends",
  //       videoLink: "https://www.youtube.com/embed/jNQXAC9IVRw",
  //     },
  //     {
  //       title: "Forecast Future Market Conditions",
  //       videoLink: "https://www.youtube.com/embed/oHg5SJYRHA0",
  //     },
  //     {
  //       title: "See what consumers are searching on different channels",
  //       videoLink: "https://www.youtube.com/embed/tgbNymZ7vqY",
  //     },
  //   ],
  // },
  // {
  //   category: "All Courses",
  //   items: [
  //     {
  //       title: "Discover Emerging Trends",
  //       videoLink: "https://www.youtube.com/embed/3fumBcKC6RE",
  //     },
  //     {
  //       title: "See the top questions consumers ask about any topic",
  //       videoLink: "https://www.youtube.com/embed/ysz5S6PUM-U",
  //     },
  //     {
  //       title: "See where consumers are talking most about any topic",
  //       videoLink: "https://www.youtube.com/embed/dQw4w9WgXcQ",
  //     },
  //     {
  //       title: "Differentiate fads from trends",
  //       videoLink: "https://www.youtube.com/embed/jNQXAC9IVRw",
  //     },
  //     {
  //       title: "Forecast Future Market Conditions",
  //       videoLink: "https://www.youtube.com/embed/oHg5SJYRHA0",
  //     },
  //     {
  //       title: "See what consumers are searching on different channels",
  //       videoLink: "https://www.youtube.com/embed/tgbNymZ7vqY",
  //     },
  //   ],
  // },
];

/**
 * @description Tutorial button component for student dashboard.
 * @returns {JSX.Element} Tutorial button component.
 */

export default function TutorialButton() {
  // states
  // const [expanded, setExpanded] = useState(0);
  const [accordiansState, setAccordiansState] = useState({});

  const [videoData, setVideoData] = useState({
    open: false,
    title: "",
    link: "",
  });

  //Redux for tutorial expanded state
  const isExpanded = useSelector((state) => state.tutorial);
  const showVideo = useSelector((state) => state.demo.demo);
  const dispatch = useDispatch();

  // UseEffects
  // Initially keep all accordians opened
  useEffect(() => {
    const initial = {};
    data.forEach((_, index) => (initial[index] = true));
    setAccordiansState(initial);
  }, []);

  //Components

  /**
   * VideoOptions Component: Shows the video options in the category body
   * @param {object} options - Options to pass
   * @returns {JSX } - Returns the video options in a list format
   */
  function VideoOptions({ options }) {
    return (
      <ul
        style={{
          listStyleType: "none",
        }}
      >
        {options?.map((option, index) => {
          return (
            <li
              style={{
                display: "flex",
                justifyItems: "center",
                alignItems: "center",
                gap: "5px",
              }}
              className={styles.video_option}
              key={index}
              onClick={(e) => {
                e.stopPropagation();
                setVideoData((prev) => ({
                  ...prev,
                  open: true,
                  title: option.title,
                  link: option.videoLink,
                }));
              }}
            >
              <SlowMotionVideoOutlinedIcon
                sx={{
                  fontSize: "15px",
                }}
              />
              {option.title}
            </li>
          );
        })}
      </ul>
    );
  }

  /**
   * CategoryOption Component: shows category and video options in the card body
   * @returns {JSX} - Returns the category and video options in the card body
   */
  function CategoryOption() {
    return (
      <>
        {data.map((item, index) => {
          return (
            //MUI v5 accordion component
            // this will show the video options in the card body

            <Accordion
              expanded={accordiansState[index]}
              onChange={handleChange(index)}
              key={index}
              sx={{
                "&.MuiAccordion-root": {
                  border: "none",
                  boxShadow: "none",
                  margin: "0 !important",
                  "&:not(:last-child)": {
                    borderBottom: 0,
                  },
                  "&:before": {
                    display: "none",
                  },
                  "&.Mui-expanded": {
                    margin: "0 !important",
                  },
                },
              }}
            >
              {/* category */}
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel-content"
                id="panel-header"
                sx={{
                  fontWeight: "600",
                  fontSize: "14px",
                  borderBottom: "none",
                  minHeight: "auto",
                  "& .MuiAccordionSummary-content": {
                    margin: "0 !important",
                  },
                  "&.Mui-expanded": {
                    minHeight: "auto",
                    margin: "0 !important",
                  },
                }}
              >
                <div>{item.category}</div>
              </AccordionSummary>
              {/* category videos options show on click */}
              <AccordionDetails
                sx={{
                  margin: "0",
                  marginLeft: "10px",
                  "& ul": {
                    listStyleType: "disc",
                    marginTop: "0",
                    paddingTop: "0",
                  },
                  "& li": {
                    marginBottom: "4px",
                  },
                  "& li:last-child": {
                    marginBottom: "0",
                  },
                }}
              >
                <Typography>
                  <VideoOptions key={index} options={item.items} />
                </Typography>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </>
    );
  }

  /**
   * handleChange: function to handle the accordion change
   * @param {*} - take the current catrgory index clicked by user
   */
  const handleChange = (panel) => (_, isExpanded) => {
    // setExpanded(isExpanded ? panel : false);
    setAccordiansState((prev) => ({
      ...prev,
      [panel]: isExpanded,
    }));
  };

  /**
   * ExpandedTutorial: function to show the expanded tutorial card
   * @returns {JSX} - Returns the expanded tutorial card
   */

  function ExpandedTutorial() {
    return (
      <div className={styles.card}>
        <CloseIcon
          sx={{
            position: "absolute",
            top: "15px",
            right: "15px",
            cursor: "pointer",
            color: "#555",
          }}
          onClick={(e) => {
            e.stopPropagation();
            dispatch(setTutorialExpanded(false));
          }}
        />
        {/* card body */}
        <div className={styles.card_body}>
          <div className={styles.card_header}>
            <h2>Welcome to Your Learning Journey</h2>
            <p>Discover all features to enhance your learning experience</p>
          </div>
          {/* dashboard demo video section*/}
          {/* <div
            className={styles.card_demo}
            onClick={() =>
              dispatch(
                setDemoObj({
                  demo: true,
                  link: "interactive",
                })
              )
            }
          >
            <div className={styles.card_demo_title}>
              <span>Start Demo</span>
              <EastOutlinedIcon
                sx={{
                  fontSize: "15px",
                  marginLeft: "5px",
                  marginTop: "2px",
                }}
              />
            </div>
            <p className={styles.card_demo_description}>
              Start the onboarding tour so you can see all the main features.
            </p>
          </div> */}
          <div
            className={styles.card_demo}
            onClick={(e) => {
              e.stopPropagation();
              dispatch(
                setDemoObj({
                  demo: true,
                  link: "interactive",
                })
              );
            }}
          >
            <div className={styles.card_body}>
              <PlayCircleOutlineIcon sx={{ fontSize: "28px" }} />
              <p>Start Interactive Tour</p>
            </div>
            <ArrowForwardIcon sx={{ fontSize: "22px" }} />
          </div>
          <div className={styles.card_list}>
            {cardDemoList.map((item, index) => {
              return (
                <div
                  key={index}
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <CheckCircleOutlineIcon
                    sx={{ fontSize: "16px", color: "#3959fd" }}
                  />{" "}
                  {item}
                </div>
              );
            })}
          </div>

          {/* videos category section */}
          <div className={styles.card_videos}>
            <div className={styles.card_demo_title}>
              <span>Tutorials Videos</span>
              <EastOutlinedIcon
                sx={{
                  fontSize: "15px",
                  marginLeft: "5px",
                  marginTop: "2px",
                }}
              />
            </div>

            {/* video category & video option */}
            <CategoryOption />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      {/* expand card with condition */}

      {isExpanded && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.3)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          onClick={() => dispatch(setTutorialExpanded(false))}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              gap: "30px",
            }}
          >
            <ExpandedTutorial />
            {/* <button
              style={{
                // position: "absolute",
                // bottom: 100,
                background: "#f5f5f5",
                border: "none",
                borderRadius: 6,
                padding: "6px 18px",
                fontWeight: 600,
                color: "#333",
                cursor: "pointer",
                fontSize: 15,
                zIndex: 999,
                boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
              }}
              onClick={() => dispatch(setTutorialExpanded(false))}
            >
              Skip
            </button> */}
          </div>
          {/* Skip button */}
        </div>
      )}

      {/* demovideo component */}
      {showVideo && <StudentDemo />}
      {videoData.open && isExpanded && (
        <VideoModal
          title={videoData.title}
          videoLink={videoData.link}
          clickHandler={() => {
            setVideoData((prev) => ({ ...prev, open: false }));
          }}
        />
      )}
    </div>
  );
}
